import React, { FC } from 'react'

import ParentProductGridCard, { type ParentProductCardGridProps } from './GridCard'
import ParentProductListCard, { type ParentProductListCardProps } from './ListCard'

export type ParentProductCardProps =
  | (ParentProductCardGridProps & {
      view?: never
    })
  | (ParentProductCardGridProps & {
      view: 'grid'
    })
  | (ParentProductListCardProps & {
      view: 'list'
    })

// TODO: Check if isAuthenticated is needed after M2 update to remove prices for guests
const ParentProductCard: FC<ParentProductCardProps> = (props) => {
  if (props.view === 'list') {
    return <ParentProductListCard {...props} />
  }

  return <ParentProductGridCard {...props} />
}

export default ParentProductCard
